export const state = () => ({
    isJJ: false,
    currentHost: "",
    shopsList: [],

    showDialogLoading: false
})

export const mutations = {
    setIsJJ: function (state, isJJ) {
        state.isJJ = isJJ;
    },
    setCurrentHost: function (state, currentHost) {
        state.currentHost = currentHost;
    },
    setShopsList: function (state, shopsList) {
        state.shopsList = shopsList;
    },
    setShowDialogLoading: function (state, showDialogLoading) {
      state.showDialogLoading = showDialogLoading;
    }
}

export const getters = {
    isJJ: ({isJJ}) => isJJ,
    currentHost: ({currentHost}) => currentHost
}

